import { useCallback } from 'react';

interface Props {
  prendasEvitar: string[];
  setPrendasEvitar: (v: string[] | ((prev: string[]) => string[])) => void;
}

const PRENDAS_A_EVITAR_OPCIONES = [
  'Estampados florales grandes', 'Colores neón', 'Siluetas oversized',
  'Minifaldas', 'Telas sintéticas brillantes', 'Cuadros escoceses',
  'Rayas horizontales anchas', 'Cuello alto muy apretado',
  'Pantalones cargo', 'Terciopelo oscuro', 'Botas de caña alta',
  'Blazers con hombreras exageradas',
];

export default function PrendasEvitarSection({ prendasEvitar, setPrendasEvitar }: Props) {
  const togglePrendaEvitar = useCallback((prenda: string) => {
    setPrendasEvitar((prev) =>
      prev.includes(prenda) ? prev.filter((p) => p !== prenda) : [...prev, prenda]
    );
  }, [setPrendasEvitar]);

  return (
    <div className="bg-white border border-brand-gray-200 rounded-2xl p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-full bg-red-50 flex items-center justify-center text-red-500">
          <i className="ri-forbid-line text-lg" />
        </div>
        <div>
          <h3 className="font-serif text-brand-black text-lg font-medium">Prendas a evitar</h3>
          <p className="font-sans text-brand-gray-500 text-xs mt-0.5">
            Selecciona qué tipos de prenda no favorecen al cliente
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {PRENDAS_A_EVITAR_OPCIONES.map((prenda) => {
          const selected = prendasEvitar.includes(prenda);
          return (
            <label
              key={prenda}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-lg border cursor-pointer transition-all ${
                selected
                  ? 'border-red-300 bg-red-50'
                  : 'border-brand-gray-200 hover:border-brand-gray-400'
              }`}
            >
              <input
                type="checkbox"
                checked={selected}
                onChange={() => togglePrendaEvitar(prenda)}
                className="w-4 h-4 accent-brand-black cursor-pointer shrink-0"
              />
              <span className={`font-sans text-sm ${selected ? 'text-red-700 font-medium' : 'text-brand-gray-600'}`}>
                {prenda}
              </span>
            </label>
          );
        })}
      </div>
    </div>
  );
}